import { defineMessages } from 'react-intl-next';

const _default_1: {
    conversationForbiddenTitle: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    conversationForbiddenDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
    conversationForbiddenTitle: {
        id: 'ai-mate.conversation-assistant.flag.conversation-forbidden.title',
        defaultMessage: 'This conversation is not available',
        description: 'Title for the flag shown when a user tries to open a conversation they do not have permission to view',
    },
    conversationForbiddenDescription: {
        id: 'ai-mate.conversation-assistant.flag.conversation-forbidden.description',
        defaultMessage: 'The conversation you tried to open may belong to another user or you may not have permission to view it.',
        description: 'Description for the flag shown when a user tries to open a conversation they do not have permission to view',
    },
});
export default _default_1;
